import {IGumballWizardState} from "../../../types/ui/wizard/gumball";
import {GumballPages} from "../../../types/types";

export const initialGumballState: IGumballWizardState = {
  page: GumballPages.Default,
  digitalMaterialIds: []
};
